import React from "react"

import { i18n, I18nTextPath, RecallTextPath } from "@/i18n"


interface TextProps extends React.HTMLAttributes<HTMLDivElement> {
    type: "main" | "recall"
    path: I18nTextPath | RecallTextPath
    params?: Record<string, string | number>
}

const Text: React.FC<TextProps> = ({
    type,
    path,
    params = {},
    className,
    style,
    ...restProps
}) => {
    const text =
        type === "main"
            ? i18n.get(path as I18nTextPath, params)
            : i18n.getRecall(path as RecallTextPath, params)

    return (
        <div className={className} style={style} {...restProps}>
            {text}
        </div>
    )
}

export default Text;